import { createTheme } from "@mui/material/styles";
import interVariableWoff2 from "../assets/fonts/InterVariable.woff2";
import {
  colorTokens,
  controlHeight,
  focusRing,
  fontFamily,
  radiusTokens,
} from "./tokens";

// Self-hosted Inter, same origin, no CDN request (docs/design/leeft-design-tokens.md
// section 3.3). font-display: swap avoids invisible text while it loads.
const interFontFace = `
  @font-face {
    font-family: "Inter";
    src: url(${interVariableWoff2}) format("woff2");
    font-weight: 100 900;
    font-style: normal;
    font-display: swap;
  }
`;

// Single light theme (manager decision, no dark mode, no toggle). Every
// value below is taken from docs/design/leeft-design-tokens.md section 3.
export const leeftTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: colorTokens.button,
      dark: colorTokens.buttonHover,
      contrastText: colorTokens.onBrand,
    },
    secondary: {
      main: colorTokens.brand,
      dark: colorTokens.brandHover,
      contrastText: colorTokens.onBrand,
    },
    error: { main: colorTokens.danger },
    success: { main: colorTokens.success },
    warning: {
      main: colorTokens.warningBg,
      contrastText: colorTokens.text,
    },
    info: { main: colorTokens.info },
    background: {
      default: colorTokens.bg,
      paper: colorTokens.surface,
    },
    text: {
      primary: colorTokens.text,
      secondary: colorTokens.textMuted,
    },
    divider: colorTokens.borderDivider,
  },
  typography: {
    fontFamily,
    button: { textTransform: "none", fontWeight: 500 },
  },
  shape: {
    borderRadius: radiusTokens.md,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: interFontFace,
    },
    MuiButton: {
      // The SSO reference button is flat, no drop shadow (section 2.4).
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: radiusTokens.pill,
          fontWeight: 600,
        },
        sizeLarge: {
          minHeight: controlHeight,
          paddingLeft: 24,
          paddingRight: 24,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: colorTokens.surface,
          borderRadius: radiusTokens.input,
          "& fieldset": {
            borderColor: colorTokens.borderControl,
          },
          "&:hover fieldset": {
            borderColor: colorTokens.borderControl,
          },
          "&.Mui-focused fieldset": {
            borderColor: colorTokens.brand,
            borderWidth: 1,
          },
        },
        input: {
          paddingTop: 16,
          paddingBottom: 16,
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: colorTokens.text,
          fontWeight: 700,
          marginBottom: 8,
          "&.Mui-focused": {
            color: colorTokens.text,
          },
        },
      },
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: false,
      },
      styleOverrides: {
        root: {
          "&.Mui-focusVisible": {
            boxShadow: focusRing,
          },
        },
      },
    },
  },
});
